import React, { PropsWithChildren } from "react";
import CustomButton from "../components/commonComponents/CustomButton";
import { BsArrowLeft } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import DownloadAppBanner from "../components/commonComponents/DownloadAppBanner";
import { useAppSelector } from "../services/store";
import { getShowDownloadAppBanner } from "src/shared/redux-state/src";
import { useWindowWidth } from "../utilities/helpers";
import { usePreviousRoute } from "../guards/PreviousRouteContext";
import { AppRoutes } from "../navigation/routes";

type IProps = {
    fixedFooter?: boolean,
    title?: string,
    renderLayoutRightHtml?: () => JSX.Element,
}
const BackButtonLayout: React.FC<PropsWithChildren<IProps>> = ({ children, fixedFooter = false, title, renderLayoutRightHtml}) => {
    const navigate = useNavigate();
    const {previousRoute} = usePreviousRoute();
    
    const showDownloadAppBanner = useAppSelector(getShowDownloadAppBanner);
    const width = useWindowWidth();

    return (
        <div className={`main-wrapper bg-white container ${showDownloadAppBanner ? (width > 567 ? 'pd-t-86' : 'pd-t-92') : 'pd-t-50'} ${fixedFooter ? 'pd-b-70' : 'pd-b-20'}`}>
            <div className={`header ${showDownloadAppBanner ? 'h-auto' : ''}`}>
                {showDownloadAppBanner ? <DownloadAppBanner /> : null}
                <div className='container h-100'>
                    <div className='row align-items-center h-100'>
                        <div className='col-sm-2 col-2'>
                            <CustomButton icon={<BsArrowLeft size={24} />}
                                color="link"
                                onClick={() => {
                                    if (!previousRoute || previousRoute === AppRoutes.UNSUBSCRIBE_EMAILS || (previousRoute && previousRoute.includes('deep-link'))) {
                                        navigate(AppRoutes.HOME) 
                                    }
                                    else navigate(-1)
                                }}
                                customBtnStyle='custom-btn-icon' />
                        </div>
                        {title && 
                            <>
                                <div className='col-sm-8 col-7 me-auto'>
                                <div className='fs-6 fw-semibold text-black mb-0 text-center text-truncate'>{title}</div>
                                </div>
                            </>
                        }
                        {renderLayoutRightHtml && renderLayoutRightHtml()}
                    </div>
                </div>
            </div>
            {children}
        </div>
    );
}

export default BackButtonLayout;